import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

// use with the Angular directive [innerHTML] to prevent XSS attacks
@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(style): SafeStyle {
    return this.sanitizer.bypassSecurityTrustHtml(style);
  }
}
